import { FlatItem } from '@martech-solution/utils/types';
import { IJobCategory, JobCategoryAdd } from 'src/types/master_data/jobCategory.type';
import { EJobTaskTypeEnum, IJobTask } from 'src/types/master_data/jobTask.type';
import { PagedList } from 'src/types/pagedList.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/job-categories';

export async function getJobCategoriesDropdown() {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
}

export const getJobCategories = async (
  page: number,
  pageSize: number,
  orderBy?: string,
  searchCondition?: string,
  sequenceStatus?: string,
  departmentId?: number
) => {
  return await http.get<PagedList<IJobCategory>>(`${controller}`, {
    params: {
      page,
      pageSize,
      orderBy,
      searchCondition,
      sequenceStatus,
      departmentId
    }
  });
};

export const getJobCategory = async (id: number) => {
  return http.get<IJobCategory>(`${controller}/${id}`);
};

export const getJobTasksDropdown = async () => {
  //FIXME: Dùng PersonalTask cho Portal, nào gộp source thì sửa lại login để truyền vào
  return http.get<FlatItem[]>(`${controller}/job-tasks/dropdown/${EJobTaskTypeEnum.PersonalTask}`);
};
export const getCategoryJobTasksByJobTaskType = async () => {
  //FIXME: Dùng PersonalTask cho Portal, nào gộp source thì sửa lại login để truyền vào
  return http.get<IJobTask[]>(`${controller}/job-tasks/${EJobTaskTypeEnum.PersonalTask}`);
};

export const addJobCategory = async (jobCategory: JobCategoryAdd) => {
  return http.post<JobCategoryAdd>(controller, jobCategory);
};

export const updateJobCategory = async (id: number, jobCategory: IJobCategory) => {
  return await http.put<IJobCategory[]>(`${controller}/${id}`, jobCategory);
};

export const deleteJobCategory = async (id: number) => {
  await http.delete(`${controller}/${id}`);
};
